import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from "yup";
import LoadingOverlay from 'react-loading-overlay';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useDispatch } from 'react-redux';
import { handlePostRequest } from '../../services/PostTemplate';
import { handlePatchRequest } from '../../services/PatchTemplate';
import { useHistory, useLocation } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';

const AddEditPromocode = () => {

    const location = useLocation()
    const { isEditable, rowData } = location?.state || {};
    const [saveBtnLoading, setSaveBtnLoading] = useState(false)
    const [isActive, setIsActive] = useState(false)

    const history = useHistory()
    const dispatch = useDispatch()

    const validationSchema = Yup.object().shape({
        code: Yup.string().required("Promocode is required."),
        userEmail: Yup.string().email("Invalid email address").required("User email is required."),
        discountPercentage: Yup.number().required("Discount percentage is required.").min(1, "Minimum 1%").max(100, "Maximum 100%"),
        validUntil: isEditable 
            ? Yup.date().required("Valid until date is required.")
            : Yup.date().required("Valid until date is required.").min(new Date(), "Date must be in the future"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            code: "",
            userEmail: "",
            discountPercentage: 0,
            validUntil: null,
        },

        onSubmit: async (data) => {
            if (isEditable) {
                setSaveBtnLoading(true);
                setIsActive(true);

                let obj = {
                    code: formik.values.code,
                    userEmail: formik.values.userEmail,
                    discountPercentage: formik.values.discountPercentage,
                    validUntil: formik.values.validUntil ? new Date(formik.values.validUntil).toISOString() : null,
                }

                const response = await dispatch(handlePatchRequest(obj, `/promocode/${rowData?._id}`, true, true));
                if (response?.status === 'success' || response?.statusCode === 200 || response?.statusCode === 201) {
                    history.push('./promocodes')
                    setSaveBtnLoading(false);
                    setIsActive(false);
                } else {
                    setSaveBtnLoading(false);
                    setIsActive(false);
                }
            } else {
                setSaveBtnLoading(true);
                setIsActive(true);

                let obj = {
                    code: formik.values.code,
                    userEmail: formik.values.userEmail,
                    discountPercentage: formik.values.discountPercentage,
                    validUntil: formik.values.validUntil ? new Date(formik.values.validUntil).toISOString() : null,
                }

                const response = await dispatch(handlePostRequest(obj, "/promocode/create", true, true));
                if (response?.status === 'success' || response?.statusCode === 200 || response?.statusCode === 201) {
                    history.push('./promocodes')
                    setSaveBtnLoading(false);
                    setIsActive(false);
                } else {
                    setSaveBtnLoading(false);
                    setIsActive(false);
                }
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    //Get Promocode By Id
    const getPromocodeById = async (rowData) => {
        setIsActive(true)
        if (rowData) {
            formik.setFieldValue('code', rowData?.code || '');
            formik.setFieldValue('userEmail', rowData?.userEmail || '');
            formik.setFieldValue('discountPercentage', rowData?.discountPercentage || 0);
            
            if (rowData?.validUntil) {
                formik.setFieldValue('validUntil', new Date(rowData.validUntil));
            }
        }
        setIsActive(false)
    }

    useEffect(() => {
        if (isEditable && rowData) {
            getPromocodeById(rowData);
        }
    }, [isEditable, rowData])

    return (
        <>
            <LoadingOverlay
                active={isActive}
                spinner={<Triangle
                    height="120"
                    width="120"
                    color="#dc2626"
                    ariaLabel="triangle-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                />}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        background: 'rgb(38 41 51 / 78%)',
                    })
                }}
            >
                <div className="flex flex-column align-items-start md:flex-row  md:justify-content-between md:align-items-center mb-4">
                    <h4 className="mb-0" style={{ fontWeight: '600', letterSpacing: '0.5px', color: 'black' }}>
                        {isEditable ? 'Edit Promocode' : 'Add New Promocode'}
                    </h4>
                </div>

                <div className="card">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="grid">
                            {/* Promocode */}
                            <div className="col-12 md:col-6">
                                <div className="input-card flex flex-column p-3">
                                    <div className='flex-row'>
                                        <label>Promocode</label>
                                        <span className="Label__Required">*</span>
                                    </div>
                                    <InputText
                                        className="p-inputtext-sm"
                                        id="code"
                                        name="code"
                                        value={formik.values.code}
                                        onChange={formik.handleChange}
                                        placeholder="Enter promocode (e.g., SAVE10)"
                                        style={{ textTransform: 'uppercase' }}
                                    />
                                    <span className='ml-2'>
                                        {getFormErrorMessage('code')}
                                    </span>
                                </div>
                            </div>

                            {/* User Email */}
                            <div className="col-12 md:col-6">
                                <div className="input-card flex flex-column p-3">
                                    <div className='flex-row'>
                                        <label>User Email</label>
                                        <span className="Label__Required">*</span>
                                    </div>
                                    <InputText
                                        className="p-inputtext-sm"
                                        id="userEmail"
                                        name="userEmail"
                                        type="email"
                                        value={formik.values.userEmail}
                                        onChange={formik.handleChange}
                                        placeholder="Enter user email"
                                    />
                                    <span className='ml-2'>
                                        {getFormErrorMessage('userEmail')}
                                    </span>
                                </div>
                            </div>

                            {/* Discount Percentage */}
                            <div className="col-12 md:col-6">
                                <div className="input-card flex flex-column p-3">
                                    <div className='flex-row'>
                                        <label>Discount Percentage (%)</label>
                                        <span className="Label__Required">*</span>
                                    </div>
                                    <InputNumber
                                        id="discountPercentage"
                                        name="discountPercentage"
                                        value={formik.values.discountPercentage}
                                        onValueChange={(e) => formik.setFieldValue('discountPercentage', e.value || 0)}
                                        min={1}
                                        max={100}
                                        placeholder="Enter discount percentage"
                                        className={isFormFieldValid('discountPercentage') ? 'p-invalid' : ''}
                                        style={{ width: '100%' }}
                                    />
                                    <span className='ml-2'>
                                        {getFormErrorMessage('discountPercentage')}
                                    </span>
                                </div>
                            </div>

                            {/* Valid Until */}
                            <div className="col-12 md:col-6">
                                <div className="input-card flex flex-column p-3">
                                    <div className='flex-row'>
                                        <label>Valid Until</label>
                                        <span className="Label__Required">*</span>
                                    </div>
                                    <Calendar
                                        id="validUntil"
                                        name="validUntil"
                                        value={formik.values.validUntil}
                                        onChange={(e) => formik.setFieldValue('validUntil', e.value)}
                                        showTime
                                        hourFormat="12"
                                        dateFormat="mm/dd/yy"
                                        placeholder="Select expiry date"
                                        className={isFormFieldValid('validUntil') ? 'p-invalid' : ''}
                                        style={{ width: '100%' }}
                                        minDate={isEditable ? null : new Date()}
                                    />
                                    <span className='ml-2'>
                                        {getFormErrorMessage('validUntil')}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex justify-content-end mt-4">
                            <Button
                                type="button"
                                label="Cancel"
                                icon="pi pi-times"
                                className="p-button-text mr-2"
                                onClick={() => history.push('./promocodes')}
                            />
                            <Button
                                type="submit"
                                label={isEditable ? "Update Promocode" : "Create Promocode"}
                                icon="pi pi-check"
                                loading={saveBtnLoading}
                                className="Add__New-Button"
                            />
                        </div>
                    </form>
                </div>
            </LoadingOverlay>
        </>
    );
};

export default AddEditPromocode;

